import React from "react";
import { fmtDate, fmtRelative } from "../lib/format";
import { Markdown } from "./Markdown";
import { Bot, User, Settings as Gear, AlertTriangle } from "lucide-react";

function iconFor(actor, eventType) {
  if (eventType === "error") return <AlertTriangle className="h-3.5 w-3.5" />;
  if (actor === "agent") return <Bot className="h-3.5 w-3.5" />;
  if (actor === "ceo") return <User className="h-3.5 w-3.5" />;
  return <Gear className="h-3.5 w-3.5" />;
}

function EmergentSummary({ event }) {
  const [open, setOpen] = React.useState(false);
  const txt = event.message || "";
  const len = txt.length;
  return (
    <div className="mt-1">
      <button
        onClick={() => setOpen((v) => !v)}
        className="text-xs font-mono text-primary hover:underline"
        data-testid={`emergent-summary-toggle-${event.id}`}
      >
        {open ? "Hide" : "Show"} emergent summary ({len} chars)
      </button>
      {open && (
        <div className="mt-2 border border-border rounded-lg p-3 bg-muted/40">
          <Markdown>{txt}</Markdown>
        </div>
      )}
    </div>
  );
}

export function Timeline({ events = [] }) {
  if (!events.length) {
    return (
      <div className="text-sm text-muted-foreground font-mono" data-testid="timeline-empty">
        No events yet.
      </div>
    );
  }
  return (
    <ol className="relative border-l border-border pl-4 space-y-4" data-testid="timeline">
      {events.map((e) => {
        const isError = e.event_type === "error";
        const isEmergent = e.event_type === "emergent_summary";
        return (
          <li
            key={e.id}
            className={`relative ${isError ? "pl-2 border-l-2 border-rose-500 -ml-[18px]" : ""}`}
            data-testid={`timeline-event-${e.id}`}
          >
            <span
              className={`absolute -left-[22px] top-1 flex h-4 w-4 items-center justify-center rounded-full border ${
                isError
                  ? "bg-rose-500/20 border-rose-500 text-rose-500"
                  : "bg-background border-border text-muted-foreground"
              }`}
            >
              {iconFor(e.actor_type, e.event_type)}
            </span>
            <div className="flex items-center gap-2 text-xs font-mono text-muted-foreground">
              <span
                className={`uppercase tracking-wider ${isError ? "text-rose-500 font-semibold" : ""}`}
              >
                {e.event_type}
              </span>
              <span>·</span>
              <span>{e.actor_name}</span>
              <span>·</span>
              <span title={fmtDate(e.created_at)}>{fmtRelative(e.created_at)}</span>
            </div>
            {isEmergent ? (
              <EmergentSummary event={e} />
            ) : (
              e.message && (
                <p className={`text-sm mt-1 ${isError ? "text-rose-500" : "text-foreground"}`}>
                  {e.message}
                </p>
              )
            )}
          </li>
        );
      })}
    </ol>
  );
}
